export default __webpack_public_path__ + "static/media/matt_headshot.94019b43.png";